import { DELETE, GET, POST, PUT } from "request/service";

// 导入形状（GeoJSON Feature）接口请求体
export interface ImportShapeFeaturePayload {
  type: "Feature";
  properties: {
    sourceId: string;
    sourceType: "IMPORT";
    geometryType: "POLYLINE" | "POLYGON";
    projectType: "GROUND" | "ABOVE" | "UNDER";
    shapeName: string;
    spatial: "WGS84" | "GCJ02";
  };
  geometry: {
    type: "LineString" | "Polygon";
    coordinates: number[][] | number[][][];
  };
}

// 统一响应结构：当前仅依赖 code/message/data.id
export interface ShapeImportResponse {
  code: number;
  message?: string;
  msg?: string;
  data?: {
    id?: string;
    createTime?: number;
    [key: string]: any;
  };
  [key: string]: any;
}

export interface ShapeListQuery {
  sourceType?: string;
  geometryType?: "POINT" | "POLYLINE" | "POLYGON";
  projectType?: string;
  shapeName?: string;
}

export interface ShapeListItem {
  id?: string;
  shapeName?: string;
  projectType?: "GROUND" | "ABOVE" | "UNDER";
  geometryInfo?: string;
  createTime: number;
  spatial?: "WGS84" | "GCJ02";
  sourceType?: "INPUT" | "IMPORT";
  geometryType?: "POLYLINE" | "POLYGON";
  [key: string]: any;
}

// 新增形状（geometryInfo 字符串）接口请求体
export interface AddShapePayload {
  sourceId: string;
  sourceType: "INPUT";
  geometryType: "POLYLINE" | "POLYGON";
  projectType: "GROUND" | "ABOVE" | "UNDER";
  shapeName: string;
  geometryInfo: string;
  spatial?: "WGS84" | "GCJ02";
}

export interface UpdateShapePayload {
  id: string;
  sourceId: string;
  sourceType: "INPUT" | "IMPORT";
  geometryType: "POLYLINE" | "POLYGON";
  projectType: "GROUND" | "ABOVE" | "UNDER";
  shapeName: string;
  spatial?: "WGS84" | "GCJ02";
  geometryInfo: string;
}

// 调用后端导入接口，返回业务响应对象
export const importShapeFeature = async (
  payload: ImportShapeFeaturePayload
): Promise<ShapeImportResponse> => {
  const response = await POST(
    `/polyanalysis-api/manage/shape/import/feature`,
    payload
  );
  return response as unknown as ShapeImportResponse;
};

// 调用后端新增形状接口，返回业务响应对象
export const addShape = async (
  payload: AddShapePayload
): Promise<ShapeImportResponse> => {
  const response = await POST(`/polyanalysis-api/manage/shape/add`, payload);
  return response as unknown as ShapeImportResponse;
};

// 调用后端删除形状接口
export const deleteShape = async (id: string): Promise<ShapeImportResponse> => {
  const response = await DELETE(`/polyanalysis-api/manage/shape/delete/${id}`);
  return response as unknown as ShapeImportResponse;
};

// 调用后端编辑形状接口
export const updateShape = async (
  id: string,
  payload: UpdateShapePayload
): Promise<ShapeImportResponse> => {
  const response = await PUT(
    `/polyanalysis-api/manage/shape/update/${id}`,
    payload
  );
  return response as unknown as ShapeImportResponse;
};

// 调用后端列表接口，获取形状数据
export const getShapeList = async (
  params?: ShapeListQuery
): Promise<ShapeImportResponse> => {
  const response = await GET(`/polyanalysis-api/manage/shape/list`, { params });
  return response as unknown as ShapeImportResponse;
};
